import { memo, useEffect, useState } from "react"
import { Helmet } from "react-helmet"

import { conditionalFunction } from "@trueskin-web/functions"
import { useIsScreenSizeSmall } from "@trueskin-web/theme"

const TrustedShopsBadge = memo(() => {
  const [isTrustedShopsAvailable, setIsTrustedShopsAvailable] = useState(true)
  const isMobile = useIsScreenSizeSmall()

  const setTrustbadgeMobileSticky = () => {
    if (isMobile) {
      conditionalFunction({
        condition: () =>
          document.querySelector("[id^='trustbadge-topbar-container-']"),
        success: () => {
          const _tsel = document.querySelector(
            "[id^='trustbadge-topbar-container-']"
          )

          _tsel.style.position = "sticky"
          _tsel.style.top = 0
        },
      })
    }
  }

  useEffect(() => {
    window._tsConfig = {
      variant: "floating_reviews",
      yOffset: "20px",
      responsive: { variant: "topbar" },
    }

    if (window.trustbadge && window.trustbadge.reInitialize) {
      window.trustbadge.reInitialize()
    } else {
      setIsTrustedShopsAvailable(false)
    }

    return () => {
      if (window.trustbadge && window.trustbadge.remove) {
        window.trustbadge.remove()
      }
    }
  }, [])

  useEffect(setTrustbadgeMobileSticky, [isMobile])

  if (isTrustedShopsAvailable) {
    return null
  }

  return (
    <Helmet
      onChangeClientState={(_, { scriptTags }) => {
        setIsTrustedShopsAvailable(true)

        if (scriptTags?.length) {
          scriptTags[0].onload = setTrustbadgeMobileSticky
        }
      }}
    >
      <script
        defer
        src="https://widgets.trustedshops.com/js/X87585F1C27682EADDEDF263833A74895.js"
      />
    </Helmet>
  )
})

TrustedShopsBadge.displayName = "TrustedShopsBadge"

export default TrustedShopsBadge
